import React, { useEffect, useMemo, useState, useContext } from "react";
import { ProjectHalSource } from '@/halSources';
import { Schedule, Worktime, Cost, Efficiency } from './components'
import { NewSchedule } from './components/schedule'
import { Tabs } from 'antd'
import type { TabsProps } from "antd"
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { isDev } from '@/config'
import { ProjectDetailContext } from "../constant"
import { k_permission } from '../project'

type IProps = {
    project?: ProjectHalSource;
};

const k_tabKey = {
    schedule: "schedule",
    worktime: "worktime"
}

const Index: React.FC<IProps> = () => {
    const { permissions } = useContext(ProjectDetailContext)

    const tabItems = useMemo(() => {
        if(!permissions) return []
        let items = []
        if (permissions.includes(k_permission.dashboardScheduleView)) {
            items.push({
                label: '总览',
                key: k_tabKey.schedule,
                children: <NewSchedule />
            })
        }
        
        if (isDev || permissions.includes(k_permission.dashboardCostView)) {
            items.push({
                label: '成本分析',
                key: 'cost',
                children: <Cost />
            })
        }
        if (permissions.includes(k_permission.dashboardWorktimeView)) {
            items.push({
                label: '成员负荷',
                key: k_tabKey.worktime,
                children: <Worktime />
            })
        }
        // if (isDev || permissions.includes(k_permission.dashboardCostView)) {
        //     items.push({
        //         label: '项目效率',
        //         key: 'efficiency',
        //         children: <Efficiency />
        //     })
        // }
        return items
    }, [permissions])
    const { projectID } = useParams();
    const [searchParams] = useSearchParams()
    const navigate = useNavigate();
    const [tab, setTab] = useState("")
    useEffect(() => {
        const tabStr = searchParams.get("tab")
        if (tabStr) {
            const item = tabItems.find(v => v.key === tabStr)
            if (item) {
                setTab(item.key)
                return
            }
        } else {
            if (permissions && permissions.includes(k_permission.dashboardScheduleView)) {
                setTab(k_tabKey.schedule)
            } else if (permissions && permissions.includes(k_permission.dashboardWorktimeView)) {
                setTab(k_tabKey.worktime)
            }
        }
    }, [searchParams, tabItems, permissions])
    const onTabChange: TabsProps['onChange'] = (activeKey) => {
        navigate(`/projects/${projectID}/dashboard?tab=${activeKey}`);
    };
    return (
        <div>
            {/* <Schedule contracts={props.contracts}></Schedule> */}
            {/* <Worktime  /> */}
            <Tabs
                type="card"
                activeKey={tab}
                items={tabItems}
                destroyOnHidden={true}
                onChange={onTabChange}
            />
        </div>
    )
}
export default Index